import { api } from "@/lib/api";

export const STATUS_LABELS: Record<string, string> = {
  exempt: "Sin cobro (cuenta interna)", none: "Sin suscripción", trialing: "En prueba", active: "Activa",
  canceling: "Cancelada (con acceso)", past_due: "Pago pendiente", expired: "Vencida",
};

export function formatDate(iso?: string | null): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("es-MX", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export const mxn = (v: number) => `$${v.toLocaleString("es-MX")} MXN`;

export function goToStripe(url: string): boolean {
  if (window.self === window.top) {
    window.location.href = url;
    return true;
  }
  const w = window.open(url, "_blank");
  if (w) w.opener = null;
  return !!w;
}

export async function openPortal() {
  const r = await api.post<{ url: string }>("/billing/portal", { origin_url: window.location.origin });
  if (!goToStripe(r.data.url)) throw new Error("popup");
}
